import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Icon",
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 28,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Add Bookmark" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.001,
			cy: 12,
			r: 8,
			fill: "#0090da"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 8,
			width: 2,
			height: 8,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 11,
			width: 8,
			height: 2,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "none"
		})
	]
});
export default SvgAddIcon;
